import { memo } from "react";
import { useField } from "formik";

import classnames from "classnames";
import { Label } from "components/Label";
import { RadioButtonsField, IRadioButtonsFieldProps } from "components/RadioButtonsField";

interface IRadioButtonField
  extends Omit<IRadioButtonsFieldProps, "group" | "classNames"> {
  name: string;
  label?: string;
  inlineLabel?: string;
  className?: string;
  ref?: React.MutableRefObject<any>;
  require?: boolean;
  classNames?: {
    input?: string;
    message?: string;
    label?: string;
    inlineLabel?: string;
  } & IRadioButtonsFieldProps["classNames"];
}

export function FormikRadioButtonField({
  name,
  className,
  label,
  inlineLabel,
  classNames,
  require,
  ...rest
}: IRadioButtonField) {
  const [field, meta] = useField(name);
  const error = (meta.touched && meta.error) || "";
  return (
    <div
      className={classnames("flex flex-col ", className, { "pb-4": !error })}
    >
      {label && (
        <Label name={label} className={classNames?.label} required={require} />
      )}
      <div className="flex flex-row items-center">
        {inlineLabel && (
          <Label name={inlineLabel} className={classnames(classNames?.inlineLabel, "!mb-0")} required={require} />
        )}
        <RadioButtonsField
          {...field}
          {...rest}
          className={classnames(classNames?.input, "p-2 w-full  h-full text-sm")}
          group={name}
          classNames={{ inputWrapper: classNames?.inputWrapper }}
        />
      </div>
      <div className={classnames("text-xs text-red-400", classNames?.message)}>{error}</div>
    </div>
  );
}

export default memo(FormikRadioButtonField);
